import { getMemberId } from '@trello/authentication';

export const getJiraInvitePermissionsStorageKey = (cloudId: string) =>
  `${getMemberId()}-${cloudId}-inviteToJiraPermissions`;
